export default __webpack_public_path__ + "static/media/modern.360ba8db.png";